import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { Cacheable } from 'ngx-cacheable';
import { Item } from '../models/item.model';
import { User } from '../models/user.model';
import { Automobilia } from '../models/automobilia.model';
import {WantedItem} from '../models/wanted-item.model';
const cacheBuster$ = new Subject<void>();

@Injectable()
export class ApiService {

  constructor(private http: HttpClient) {
  }

  getDealers(): Observable<User[]> {
    return this.http.get<User[]>(environment.apiUrl + 'dealers');
  }

  resendActivationEmail(id: string): Observable<User> {
    return this.http.get<User>(environment.apiUrl + 'resend-activation/' + id);
  }

  getUserDetails(): Observable<User> {
    return this.http.get<User>(environment.apiUrl + 'user-details');
  }

  getSharedItems(): Observable<Item[]> {
    return this.http.get<Item[]>(environment.apiUrl + 'shared-items');
  }

  @Cacheable({
    maxCacheCount: 100,
    cacheBusterObserver: cacheBuster$
  })
  getSharedItem(id: string): Observable<Item> {
    return this.http.get<Item>(environment.apiUrl + 'shared-items/' + id);
  }

  // @Cacheable({maxCacheCount: 100})
  // getItemImage(id: string): Observable<Blob> {
  //   return this.http.get(environment.apiUrl + 'item-image/' + id, {responseType: 'blob'});
  // }

  @Cacheable({
    maxCacheCount: 100,
    cacheBusterObserver: cacheBuster$
  })
  getItemImageAsString(id: string): Observable<any> {
    return this.http.get(environment.apiUrl + 'item-image-as-string/' + id, {responseType: 'text'});
  }

  getAutomobilia(): Observable<Automobilia[]> {
    return this.http.get<Automobilia[]>(environment.apiUrl + 'automobilia');
  }

  getAutomobiliaForSale(): Observable<Automobilia[]> {
    return this.http.get<Automobilia[]>(environment.apiUrl + 'automobilia-for-sale');
  }

  getWantedItemsActive(active: boolean): Observable<WantedItem[]> {
    return this.http.get<WantedItem[]>(environment.apiUrl + 'wanted-item-active');
  }

  getWantedItem(): Observable<WantedItem[]> {
    return this.http.get<WantedItem[]>(environment.apiUrl + 'wanted-item');
  }

  postData(path, data): Observable<any> {
    return this.http.post<any>(environment.apiUrl + path, data, {observe: 'response'});
  }

  putData(path, data): Observable<any> {
    return this.http.put<any>(environment.apiUrl + path, data, {observe: 'response'});
  }

  deleteData(path): Observable<any> {
    return this.http.delete(environment.apiUrl + path);
  }

}
